module.exports = __webpack_public_path__ + "img/category-casino.0170fb5e.png";